export { default } from './AlignmentData';
